import { isString } from 'lodash';

import S from 'constants/string.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import nullBind from 'utils/functions/nullBind.util';
import randomString from 'utils/values/randomString.util';

const SEPARATOR = S.minus;

const createNodeKey = (options) => {
  const random = isString(options) ? options : options?.random;

  if (random === randomString.LONG || random === randomString.SHORT) return randomString(random);

  const segments = ['key'];

  const tag = fromAnyToTrimmed(options?.tag);
  if (tag) segments.push(tag);

  const unique = fromAnyToTrimmed(options?.unique);
  if (unique) {
    segments.push('unique', unique);
    return segments.join(SEPARATOR);
  }

  if (Number.isFinite(options?.index)) {
    segments.push('index', fromAnyToTrimmed(options?.index));
    return segments.join(SEPARATOR);
  }

  segments.push('random', randomString(randomString.SHORT));

  return segments.join(SEPARATOR);
};

createNodeKey.R_LONG = randomString.LONG;
createNodeKey.R_SHORT = randomString.SHORT;

createNodeKey.long = nullBind(createNodeKey, createNodeKey.R_LONG);
createNodeKey.short = nullBind(createNodeKey, createNodeKey.R_SHORT);

// noinspection JSUnusedGlobalSymbols
export default createNodeKey;
